export default __webpack_public_path__ + "assets/enterprise-one-four.7fc378a3d309d4df8879b31162f084ff.png";